import React, { useCallback, useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import GeneralLayout from 'src/layouts/general';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import DescriptionCardV2 from 'src/components/DescriptionCardV2';
// import { CommonSectionLayout } from 'src/pages/index';
import { localeSelector } from 'src/selector/app';
import BlogsData from 'src/consts/poswebsite_content/customerCaseBlogData';
import styles from './index.less';
import FrozenRatio from 'src/components/FrozenRatio/FrozenRatio';
import ScheduleYourFreeDemo from 'src/components/POSWebsite/ScheduleYourFreeDemo';

function CommonSectionLayout(props) {
  let { children, title, backgroundColor, classNames = '', description, subDescription, id } = props;

  return (
    <div className={`${styles.CommonSectionLayout} ${classNames}`} style={{ backgroundColor }}>
      <div className="container common-section common-section-section">
        <div className="section-content ">
          {(title || description) && (
            <div className="header">
              {title && <h1 className="bold section-title">{title}</h1>}
              {description && <p className=" section-sub-title">{description}</p>}
              {subDescription}
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}

const BusinessTypeBlog = (props) => {
  const locale = useSelector(localeSelector);
  let { blog, pageTitle } = props;
  const dispatch = useDispatch();
  const router = useRouter();

  let {
    article: {
      top: { title: topTitle, description: topDescription, youtubeVideoId, poster },
      paragraphs,
    },
  } = blog || {};

  return (
    <GeneralLayout pageClass="full-width-page" pageTitle={pageTitle}>
      <div className={styles.BusinessTypeBlog}>
        <CommonSectionLayout backgroundColor="#fffff" title={''}>
          <div className="topSection">
            <DescriptionCardV2
              posterRatio={9 / 16}
              title={topTitle}
              description={topDescription}
              poster={poster}
              youtubeVideoId={youtubeVideoId}
              playerId="businesstype_video_player"
              posterAlt={topTitle}
              videoCover={poster}
              autoPlayOnCover={true}
            />
          </div>
        </CommonSectionLayout>

        {(paragraphs || []).map((paragraphRowColumns, index) => {
          return (
            <CommonSectionLayout backgroundColor="#fffff" title={''} key={index}>
              <Row
                className={styles['row-gap']}
                gutter={paragraphRowColumns.length !== 1 ? [56, { xs: 28, sm: 30, md: 56 }] : [0]}
              >
                {paragraphRowColumns.map((column, columnindex) => {
                  let {
                    column: columnSpan,
                    content: { type, content, imageRatio, style },
                  } = column;
                  return (
                    <Col xs={24} xl={columnSpan} key={columnindex}>
                      {type === 'image' ? (
                        <div style={{ ...(style || {}) }}>
                          <FrozenRatio ratio={imageRatio}>
                            <img width="100%" src={content} alt={''} className={styles['image']} />
                          </FrozenRatio>
                        </div>
                      ) : null}
                      {type === 'text' ? (
                        <div className={paragraphRowColumns.length !== 1 ? styles['row-right-container'] : ''}>
                          {(content || []).map((section, sectionIndex) => {
                            return (
                              <p
                                key={sectionIndex}
                                style={{ ...(style || {}) }}
                                className={styles['blog-paragraph-section']}
                              >
                                {section}
                              </p>
                            );
                          })}
                        </div>
                      ) : null}
                    </Col>
                  );
                })}
              </Row>
            </CommonSectionLayout>
          );
        })}

        <div className={'scheduleYourFreeDemo'}>
          <ScheduleYourFreeDemo showModel="white_background" />
        </div>
      </div>
    </GeneralLayout>
  );
};

export default BusinessTypeBlog;

export const getStaticPaths = async ({ locales }) => {
  const paths = BlogsData.reduce((pathTemps, businessBlog) => {
    let { businessType, blogs } = businessBlog;
    blogs.map((blog) => {
      let { key } = blog;
      pathTemps.push({
        params: {
          businesstype: businessType,
          blogkey: key,
        },
      });
      pathTemps.push({
        params: {
          businesstype: businessType,
          blogkey: key,
        },
        locale: 'zh',
      });

      pathTemps.push({
        params: {
          businesstype: businessType,
          blogkey: key,
        },
        locale: 'en',
      });
    });

    return pathTemps;
  }, []);
  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return { paths, fallback: false };
};

// This function gets called at build time on server-side.
// It won't be called on client-side, so you can even do
// direct database queries.
export const getStaticProps = async ({ params, locales, locale }) => {
  try {
    const blogkey = params?.blogkey;
    const businessType = params?.businesstype;
    let matchedBlogWithBusinessType = BlogsData.find((blogdata) => {
      if (blogdata.businessType === businessType) {
        return true;
      }
      return false;
    });

    let matchedBlog = null;
    let pageTitle = '';
    if (matchedBlogWithBusinessType) {
      pageTitle = matchedBlogWithBusinessType.pageTitle;
      matchedBlog = matchedBlogWithBusinessType.blogs.find((blog) => {
        if (blog.key === blogkey) {
          return true;
        }
        return false;
      });
    }
    // By returning { props: item }, the StaticPropsDetail component
    // will receive `item` as a prop at build time
    return { props: { blog: matchedBlog, pageTitle, locale } };
  } catch (err) {
    return { props: { errors: err.message } };
  }
};
